import permissions from "app/permissions";
import { ATTESTATIONS_MANAGEMENT, STUDENT_EDUCATION, StudentServicePath } from "utils/constants";
import ManageAttestationsPage from "./ManageAttestationsPage";

export const resources = {
  name: StudentServicePath + STUDENT_EDUCATION + "/:id/" + ATTESTATIONS_MANAGEMENT,
  title: "Управление на заверки",
  custom: <ManageAttestationsPage />,
  permission: permissions.canPreviewStudentEducationAttestations,
  isMenu: false,
};
